
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFF","fill-rule":"evenodd","d":"M8 13v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6a1 1 0 011-1h2a1 1 0 011 1zm5-9h-2a1 1 0 00-1 1v14a1 1 0 001 1h2a1 1 0 001-1V5a1 1 0 00-1-1zm6 4h-2a1 1 0 00-1 1v10a1 1 0 001 1h2a1 1 0 001-1V9a1 1 0 00-1-1z","opacity":".75"}})])
          )
        }
      }
    